module.exports = "../dist/img/product-detail-1-22.96ba.jpg";